import { useContext } from 'react';
import { ProfileContext, Profile, ProfileContextType } from '@/contexts/ProfileContext';

export type { Profile };

export const useProfile = (): ProfileContextType => {
  const context = useContext(ProfileContext);
  if (context === undefined) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
};
